import React from 'react'
import Button from '../../../common/button'

/**
 * @param table
 * @param send
 */
class Announcements extends React.Component
{

    constructor(props) {
        super(props)
        this.state = {
            announcementLock: false
        }
    }

    handleAnnounce()
    {
        this.props.send({
            type: "ANNOUNCEMENT",
            announcement: this.props.table.get("possibleAnnouncement")
        })
    }

    render()
    {
        const t = this.props.table
        const player = t.get("players").find(p => p.get("id") == t.get("ownId"))
        const possibleAnnouncement = t.get("possibleAnnouncement")

        return possibleAnnouncement ? (
            <div className="announcements">
                <img
                    className="announcement-img"
                    src={ getAnnouncementImageURL(possibleAnnouncement, player.get("party")) }
                />
                <Button
                    text={ Messages("table.announcements.announce", getAnnouncementName(possibleAnnouncement, player.get("party"), false)) }
                    onClick={ this.handleAnnounce.bind(this) }
                />
            </div>
        ) : null
    }

}

function getAnnouncementName(announcement, party, fullName)
{
    let partyAnnouncement =  Messages("table.announcements." + party.toLowerCase())
    return announcement == "PARTY" 
        ? partyAnnouncement
        : (fullName ? partyAnnouncement : "") + " " + Messages("table.announcements." + announcement.toLowerCase())
}

function getAnnouncementImageURL(announcement, party)
{
    if (announcement === "PARTY")
    {
        return party === "RE"
            ? "/assets/images/party_re.png"
            : "/assets/images/party_kontra.png"
    }
    let name = announcement === "K0" ? "ab_in_den_schwarzwald" : announcement.toLowerCase()
    return "/assets/images/" + name + ".png"
}

export default Announcements
export { Announcements, getAnnouncementImageURL, getAnnouncementName }